import { ICarrier } from "./carrier";

export interface IAdjuster
{
    firstName: string;
    lastName: string;
    fullName: string;
    phoneNumber?: string;
    emailAddress?: string;
    carrier?: ICarrier;
    
}


export class Adjuster implements IAdjuster
{
    constructor
    (
        public id: number,
        public firstName: string,
        public lastName: string,
        public fullName: string,
        public phoneNumber: string,
        public emailAddress: string
    )
    {

    }    
}

export class AdjusterRole
{
    constructor
    (
        public adjuster: Adjuster,
        public role: string
    )
    {

    }

    get displayValue() : string
    {
        return `[${this.role}] ${this.adjuster.fullName} `; 
    }
}

export class AdjusterInsert
{
    constructor
    (
        public firstName: string,
        public lastName: string
    )
    {}

    static create (adjuster:IAdjuster) : AdjusterInsert
    {
        var a = new AdjusterInsert(adjuster.firstName, adjuster.lastName);
        a.phoneNumber = adjuster.phoneNumber;
        a.emailAddress = adjuster.emailAddress;
        return a;
    }

    phoneNumber?: string;
    emailAddress?: string;
}

export class AdjusterUpdate 
{
    constructor ()
    {

    }

    static create (adjuster:IAdjuster) :AdjusterUpdate
    {
        var a = new AdjusterUpdate();
        a.firstName = adjuster.firstName;
        a.lastName = adjuster.lastName;
        a.phoneNumber = adjuster.phoneNumber;
        a.emailAddress = adjuster.emailAddress;

        return a;
    }

    firstName?:string;
    lastName?:string;
    phoneNumber?:string;
    emailAddress?:string;
}